import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { MI_COVERAGE_ACTION_TYPE } from '../actions';

const initialState = {};

const miCoverageCriteriaReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case MI_COVERAGE_ACTION_TYPE.GET_CRITERIA:
        return payload || initialState;

      case MI_COVERAGE_ACTION_TYPE.ADD_CRITERIA:
      case MI_COVERAGE_ACTION_TYPE.EDIT_CRITERIA:
        draft[payload.criteriaId] = payload;
        break;

      case MI_COVERAGE_ACTION_TYPE.DELETE_CRITERIA:
        delete draft[meta.criteriaId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default miCoverageCriteriaReducer;
